import React, { useEffect, useState } from "react";
import axios from "axios";
import FormularioNuevo from "./FormularioNuevo";
import HistorialGlobal from "./HistorialGlobal";
import CalendarioCitas from "./CalendarioCitas";
import NavBarSuperior from "./NavBarSuperior";

export default function FormularioSupervisor() {
  const [activeTab, setActiveTab] = useState("nuevo");
  const [registros, setRegistros] = useState([]);
  const username = localStorage.getItem("username")?.toLowerCase();

  const fetchRegistros = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/formulario`, {
        headers: { Authorization: token },
      });
      setRegistros(res.data);
    } catch (err) {
      console.error("Error obteniendo registros:", err);
    }
  };

  useEffect(() => {
    fetchRegistros();
  }, []);

  return (
    <div className="container mt-5">
      <NavBarSuperior />
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "nuevo" ? " active" : ""}`}
            onClick={() => setActiveTab("nuevo")}
          >
            Nuevo Registro
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "historial" ? " active" : ""}`}
            onClick={() => setActiveTab("historial")}
          >
            Historial Global
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "citas" ? " active" : ""}`}
            onClick={() => setActiveTab("citas")}
          >
            Citas (WhatsApp)
          </button>
        </li>
      </ul>

      {activeTab === "nuevo" && (
        <FormularioNuevo
          usuario={username}
          modoSupervisor={true}
          onSubmit={async (formulario) => {
            const token = localStorage.getItem("token");
            try {
              await axios.post(`${process.env.REACT_APP_API_URL}/formulario`, formulario, {
                headers: { Authorization: token }
              });
              alert("Formulario enviado");
              setActiveTab("historial");
              fetchRegistros();
            } catch (err) {
              console.error("Error al guardar:", err);
              alert("Error al guardar");
            }
          }}
        />
      )}

      {activeTab === "historial" && (
        <HistorialGlobal registros={registros} modoSupervisor={true} />
      )}

      {activeTab === "citas" && (
        <div className="card shadow p-4">
          <CalendarioCitas />
        </div>
      )}
    </div>
  );
}
